/**
 * @generated SignedSource<<d450fbb0abebe5a35417639e053de590>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PackageStatus = "DRAFT" | "EXPIRED" | "PUBLISHED" | "WAITING";
import { FragmentRefs } from "relay-runtime";
export type PackageDateRow_package$data = {
  readonly status: PackageStatus;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlight_package">;
  readonly " $fragmentType": "PackageDateRow_package";
};
export type PackageDateRow_package$key = {
  readonly " $data"?: PackageDateRow_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRow_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRow_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateRowFlight_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "7945a82cdcd04ac8f654af8c443717f8";

export default node;
